import {Component} from '@angular/core';
import {FieldType} from '@ngx-formly/core';
import {APP} from '@app/app-constant';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'formly-field-file',
    template: `
        <div class="grid col-12">
            <div class="col-6">
                <input #imgURL pInputText type="hidden" [formControl]="formControl" [formlyAttributes]="field"/>
                <div class="mb-3 mt-3" *ngIf="imgURL.value">
                    <p-image [src]="imgURL.value" width="50" preview="true"></p-image>
                </div>
            </div>
            <div class="col-6 mt-5">
                <p-fileUpload mode="basic"
                              name="file"
                              [url]="uploadURL"
                              [auto]="true"
                              chooseLabel="Upload"
                              (onUpload)="onUpload($event)"
                >
                </p-fileUpload>
            </div>


        </div>
    `,


})

// tslint:disable-next-line:component-class-suffix
export class FormlyFieldFile extends FieldType {
    uploadURL = APP.uploadURL;

    onUpload($event: any) {
        this.formControl.setValue($event.originalEvent.body.url);
    }
}
